import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';
import { getConditionValue } from '@components/ui/pipe/val-condition-pipe';
import { UiModule } from '@components/ui/ui-module';
import { CardPrice, MarketPlace } from '@models/card.model';
import { Global } from '@services/global.service';
import { tap } from 'rxjs';

@Component({
  selector: 'lgb-prices-grid',
  imports: [
    CommonModule,
    UiModule
  ],
  templateUrl: './prices-grid.html',
  styleUrl: './prices-grid.css',
})
export class PricesGrid {
  //inject
  readonly global=inject(Global);

  //input/output
  readonly prices=input.required<CardPrice[]>();

  //data
  readonly markets=signal<MarketPlace[]>([]);

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);

    this.global.init()
      .pipe(
        tap(result => {
          const markets: MarketPlace[]=result.marketplaces
            .filter((m: MarketPlace) => m.type=='market')
            .sort((a: MarketPlace, b: MarketPlace) => a.index-b.index);
          this.markets.set(markets);
        })
      )
      .subscribe(() => this.loading.set(false));
  }


  getPrices(market: MarketPlace){
    return this.prices().filter(m => m.marketplace==market.ref)
      .sort((a: CardPrice, b: CardPrice) => {
        if(a.lang==b.lang)
          return getConditionValue(b.condition)-getConditionValue(a.condition);
        else
          return a.lang.localeCompare(b.lang);
      });
  }

}
